import React, { useContext, useMemo } from 'react';
import { ProductTransaction } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { CustomFieldContext } from '../../../../../../../../context/CustomFieldContext';
import { CustomFieldEntityType } from '../../../../../../../../types/custom_field';
import CustomFieldInput from '../../../../../../Common/CustomFieldInput';
import { UserContext } from '../../../../../../../../context/UserContext';
import { ContactContext } from '../../../../../../../../context/ContactContext';
import { ProductMasterDataContext } from '../../../../../../../../context/ProductMasterDataContext';

interface AssetCustomFieldsProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  productMasterData: ProductMasterData;
  disabled?: boolean;
}

export default function AssetCustomFields({
  transaction,
  setTransaction,
  productMasterData: pmd,
  disabled = false,
}: AssetCustomFieldsProps) {
  const { customFields } = useContext(CustomFieldContext);
  const { companyUsers } = useContext(UserContext);
  const { contacts } = useContext(ContactContext);
  const { productMasterData } = useContext(ProductMasterDataContext);

  const relevantCustomFields = useMemo(() => {
    return [...customFields.values()].filter(cf => cf.entityType === CustomFieldEntityType.asset && !cf.generated);
  }, [customFields]);

  return (
    <Grid item xs={6}>
      {relevantCustomFields
        .sort((a, b) => a.index - b.index)
        .map(field => {
          if (field.entityType !== CustomFieldEntityType.product) {
            return (
              <CustomFieldInput
                key={field.id}
                item={field}
                value={transaction.customFields?.get(field.id)?.value}
                entity={transaction}
                onChange={setTransaction}
                disabled={disabled}
                pmdId={transaction.product.pmdId}
                users={companyUsers}
                contacts={contacts}
                productMasterData={productMasterData}
              />
            );
          }
        })}
    </Grid>
  );
}
